/**
 * Client wrapper for the generator worker.
 *
 * The store submits generator requests here and receives typed-array results
 * back. There is intentionally no direct store-side generator execution path.
 */

import {
  callWorker,
  collectTransferables,
  createSingletonWorker,
} from "../../workers/createWorkerRPC.ts";
import type { GeneratorRequest, GeneratorResult } from "./runtime.ts";

const getWorker = createSingletonWorker(
  () =>
    new Worker(new URL("./generator.worker.ts", import.meta.url), {
      type: "module",
    }),
);

export async function executeGeneratorInWorker(
  request: GeneratorRequest,
): Promise<GeneratorResult> {
  return callWorker<GeneratorRequest, GeneratorResult>(
    getWorker(),
    request,
    collectTransferables(request),
    {
      stallWarningMs: 8_000,
      stallMessage: "Generator rebuild is taking longer than expected.",
      stallDedupKey: "generator-stall",
    },
  );
}
